/**
 * London Basket — recently viewed products (localStorage)
 */
(function () {
  var STORAGE_KEY = "lb_recently_viewed";
  var MAX_ITEMS = 8;

  function getHandles() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(Boolean).slice(0, MAX_ITEMS) : [];
    } catch (e) {
      return [];
    }
  }

  function saveHandle(handle) {
    if (!handle) return;
    var list = getHandles().filter(function (h) {
      return h !== handle;
    });
    list.unshift(handle);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
    } catch (e) {}
  }

  function trackProductPage() {
    var el = document.querySelector("[data-product-handle]");
    if (!el) return;
    saveHandle(el.getAttribute("data-product-handle"));
  }

  function formatMoney(cents) {
    if (typeof cents !== "number") return "";
    return "$" + (cents / 100).toFixed(2);
  }

  function renderLandingGrid() {
    var container = document.getElementById("lb-recently-viewed-grid");
    var section = document.getElementById("lb-recently-viewed");
    if (!container) return;

    var handles = getHandles();
    if (!handles.length) {
      if (section) section.classList.add("is-empty");
      return;
    }

    var pending = handles.length;
    var cards = [];

    handles.forEach(function (handle) {
      fetch("/products/" + encodeURIComponent(handle) + ".js")
        .then(function (res) {
          if (!res.ok) throw new Error("not found");
          return res.json();
        })
        .then(function (product) {
          cards.push(product);
        })
        .catch(function () {})
        .finally(function () {
          pending -= 1;
          if (pending === 0) finishRender(container, section, cards, handles);
        });
    });
  }

  function finishRender(container, section, products, order) {
    if (!products.length) {
      if (section) section.classList.add("is-empty");
      return;
    }

    var sorted = order
      .map(function (handle) {
        return products.find(function (p) {
          return p.handle === handle;
        });
      })
      .filter(Boolean)
      .slice(0, 4);

    container.innerHTML = sorted
      .map(function (product) {
        var img = product.featured_image || (product.images && product.images[0]);
        var src = img ? img : "";
        var alt = product.title ? product.title.replace(/"/g, "&quot;") : "";
        var price = product.price ? formatMoney(product.price) : "";
        return (
          '<a class="lb-landing-recent-card" href="/products/' +
          product.handle +
          '">' +
          (src
            ? '<img src="' + src + '" alt="' + alt + '" width="200" height="200" loading="lazy" decoding="async">'
            : "") +
          '<div class="lb-landing-recent-card__body">' +
          '<p class="lb-landing-recent-card__title">' +
          alt +
          "</p>" +
          (price ? '<p class="lb-landing-recent-card__price">' + price + "</p>" : "") +
          "</div></a>"
        );
      })
      .join("");

    if (section) section.classList.remove("is-empty");
  }

  function boot() {
    trackProductPage();
    renderLandingGrid();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
